<template>
  <div class="rounded bg-red-600 px-4 py-1 text-white">
    <h1 class="text-2xl text-white"><slot name="title"></slot></h1>
    <div class="message my-4 text-white">
      <slot name="message"></slot>
    </div>
  </div>
</template>
